import type { MapDef } from '@warcarp/api-types'
import { getBundledMap } from './bundledMaps'

/** How far (share of the top bar's height) a map may run up under the top bar. */
export const MAX_TOP_BAR_OVERLAP = 0.9

export function mapGameLayout(map: Pick<MapDef, 'id' | 'gameLayout'>) {
  // Borrow cosmetic defaults for persisted games made before this metadata existed.
  // An explicit zero/right override always wins over the bundled default.
  const defaults = getBundledMap(map.id)?.gameLayout
  const overlap = map.gameLayout?.topBarOverlap ?? defaults?.topBarOverlap ?? 0
  return {
    topBarOverlap: Number.isFinite(overlap) ? Math.max(0, Math.min(MAX_TOP_BAR_OVERLAP, overlap)) : 0,
    playerBarPosition: map.gameLayout?.playerBarPosition ?? defaults?.playerBarPosition ?? 'right',
  } as const
}

/** Shared by the live board, completed board, snapshot and keyboard/tips fit. */
export function mapChromeOffset(topBarHeight: number, overlap: number) {
  const height = Number.isFinite(topBarHeight) ? Math.max(0, topBarHeight) : 0
  return height * Math.max(0, Math.min(MAX_TOP_BAR_OVERLAP, Number.isFinite(overlap) ? overlap : 0))
}
